import React from "react";
import Subtitle from "@radarly/components/cards/card/subtitle";
import { DatavizCloud } from "@radarly/models/dataviz";
import { SearchableInfluencer } from "@radarly/models/influencer";
import { SearchFragmentUsers } from "@radarly/models/search";
import AuthorsSort from "@radarly/shared/cards/subtitle/authors-sort";
import Date from "@radarly/shared/cards/subtitle/date";
import Tile from "@radarly/shared/cards/tile";
import Cloud from "@radarly/shared/widgets/authors/cloud";
import { CardFragmentProps } from "../model";

const RadarlyAuthorCardCloud = ({
  title,
  fragment,
  project,
  dataviz,
  height,
  onClickItem,
  timezone,
  forceReload,
  nowDate,
}: CardFragmentProps<
  SearchFragmentUsers,
  DatavizCloud,
  SearchableInfluencer
>) => {
  return (
    <Tile
      title={title}
      subtitle={
        <Subtitle
          meta={[
            <Date fragment={fragment} timezone={timezone} nowDate={nowDate} />,
            <AuthorsSort fragment={fragment} />,
          ]}
        />
      }
      height={height}
      clause={fragment.request.query}
    >
      <Cloud
        fragment={fragment}
        project={project.id}
        dataviz={dataviz}
        onClickInfluencer={onClickItem}
        forceReload={forceReload}
      />
    </Tile>
  );
};

export default RadarlyAuthorCardCloud;
